import React from 'react'
import TriggerCard from './TriggerCard'
import SlotsReadOnlyTable from './SlotsReadOnlyTable'
import ActionCard from './ActionCard'
import PoliciesCard from './PoliciesCard'

export default function PlaybookEditor({ playbook, slotMetadata = {}, actionOptions = [], placeholders = [], canWrite, onChange }) {
  if (!playbook) return null
  const slots = Array.isArray(slotMetadata) ? slotMetadata : (slotMetadata[playbook.type] ?? [])
  const update = (changes) => onChange?.({ ...playbook, ...changes })
  return (
    <div className="flex flex-col gap-4">
      <TriggerCard playbook={playbook} canWrite={canWrite} onChange={update} />
      <SlotsReadOnlyTable slots={slots} />
      <ActionCard playbook={playbook} actionOptions={actionOptions} placeholders={placeholders.filter((placeholder) => !placeholder.type || placeholder.type === playbook.type)} canWrite={canWrite} onChange={update} />
      <PoliciesCard playbook={playbook} canWrite={canWrite} onChange={update} />
    </div>
  )
}
